import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { MyPromise } from '../interceptors/myPromise.service';

const COVIDAPIURL = `${environment.baseEndpoint}/covid`;

@Injectable({
  providedIn: 'root',
})
export class CovidService {

  constructor(
    private http: HttpClient,
    private myPromise: MyPromise
  ) {
  }

  store(stationId: string, employeeId: string, data: any) {
    return this.myPromise.to(this.http.post(`${COVIDAPIURL}/${stationId}/${employeeId}`, data));
  }

  update(data: any, id: any) {
    return this.myPromise.to(this.http.put(`${COVIDAPIURL}/${id}`, data));
  }

  delete(id: any) {
    return this.myPromise.to(this.http.delete(`${COVIDAPIURL}/${id}`));
  }

  storeCovidDetection(stationId: string, employeeId: string, data: any) {
    return this.myPromise.to(this.http.post(`${COVIDAPIURL}/detection/${stationId}/${employeeId}`, data));
  }

  getTestsPositiveByStationId(stationId: string) {
    return this.myPromise.to(this.http.get(`${COVIDAPIURL}/${stationId}/positive`));
  }

  getSupplies(stationId: string) {
    return this.myPromise.to(this.http.get(`${COVIDAPIURL}/${stationId}/supplies`));
  }

  storeSuppliesDelivery(stationId: string, data: any) {
    return this.myPromise.to(this.http.post(`${COVIDAPIURL}/${stationId}/delivery/supplies`, data));
  }

  storeSupplie(stationId: string, data) {
    return this.myPromise.to(this.http.post(`${COVIDAPIURL}/${stationId}/supplies/word`, data));
  }

  getTestsByStationId(stationId: string) {
    return this.myPromise.to(this.http.get(`${COVIDAPIURL}/${stationId}/tests`));
  }

  downloadFileProtectionEquipmentDelivery(stationId: string) {
    return this.myPromise.to(this.http.get(`${COVIDAPIURL}/download/${stationId}/team`));
  }
}

